<template>
  <v-container>
    <v-snackbar v-model="message.visible" :color="message.type" :timeout="message.duration" top>
      {{message.body}}
      <v-btn dark text @click="message.visible = false">Close</v-btn>
    </v-snackbar>
    <v-form>
      <v-row justify="center">
        <v-col>
          <v-text-field v-model="user.info.email" type="email" label="Email" readonly></v-text-field>
        </v-col>
        <v-col>
          <v-text-field v-model="user.info.name" label="Name" :readonly="!editing"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <v-text-field v-model="user.info.phone_number" label="Phone Number" readonly></v-text-field>
        </v-col>
        <v-col>
          <v-menu
            v-model="birthDatePicker.visible"
            ref="menu"
            :return-value.sync="birthDatePicker.value"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="birthDatePicker.value"
                label="Birth Date"
                prepend-icon="mdi-calendar"
                :readonly="!editing"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker :readonly="!editing" v-model="birthDatePicker.value" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text @click="birthDatePicker = false">Cancel</v-btn>
              <v-btn text @click="$refs.menu.save(birthDatePicker.value)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <v-select
            v-model="user.profile.country_code"
            :items="countries"
            label="Country"
            :readonly="!editing"
          ></v-select>
        </v-col>
        <v-col>
          <v-text-field v-model="user.profile.city" label="City" :readonly="!editing"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <v-text-field
            v-model="user.profile.address_line1"
            placeholder="Amman"
            label="Address Line 1"
            :readonly="!editing"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            v-model="user.profile.address_line2"
            placeholder="Maka Street.."
            label="Address Line 2"
            :readonly="!editing"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <v-btn v-if="!editing" @click="editing = true">
      <v-icon>mdi-pencil-outline</v-icon>
    </v-btn>
    <v-btn
      class="mr-3"
      width="100px"
      color="secondary"
      @click="update"
      v-if="editing"
    >{{submitting?"Saveing...":"Save"}}</v-btn>
    <v-btn color="secondary" v-if="editing" @click="editing = false">Cancel</v-btn>
  </v-container>
</template>

<script>
import { dateToTimestamp, timestampToDate } from "../../../helpers/formatters";
import { getMutatedEntries } from "../../../helpers/computers";
import MessagingMixin from "../../../mixins/messaging";

export default {
  mixins: [MessagingMixin],
  data() {
    return {
      editing: false,
      submitting: false,
      birthDatePicker: {
        visible: false,
        value: null
      },
      user: {
        info: {},
        profile: {}
      }
    };
  },

  computed: {
    countries() {
      return Object.keys(this.$store.state.countries).map(key => ({
        value: key,
        text: this.$store.state.countries[key]
      }));
    }
  },

  methods: {
    update() {
      this.submitting = true;
      let payload = getMutatedEntries(this.$store.state.user, this.user);
      this.$store.dispatch("user/updateUserProfile", payload).then(() => {
        this.submitting = false;
        this.editing = false;
        this.setMessage("Your Info updated successfully", "success");
      });
    }
  },

  watch: {
    birthDatePicker: {
      handler(picker) {
        if (picker.value)
          this.user.profile.date_of_birth = dateToTimestamp(picker.value);
      },
      deep: true
    }
  },

  mounted() {
    this.$store.dispatch("user/fetchUserProfile").then(() => {
      this.user = JSON.parse(JSON.stringify(this.$store.state.user));
      this.birthDatePicker.value = timestampToDate(
        this.user.profile.date_of_birth
      );
    });
  }
};
</script>

<style lang="scss">
</style>